import "./FMRxHistory.scss";

import cx from "classnames";
import { useSelector } from "utils/redux";

import type { MedicalHistoryTableProps } from "./medicalRecordUtils";
import RxHistoryTable from "./rx-history/RxHistoryTable";

const FMRxHistory = ({ service }: MedicalHistoryTableProps) => {
  const showRxHistory = useSelector((state) => state.drawer.showRxHistory);

  return (
    <div
      className={cx("documents documents-rx flex jc-se", {
        open: showRxHistory,
      })}
    >
      <div className="documents-wrapper overflow-hidden">
        <div className="swim-wrapper h-100">
          <div className="grid-layout gl-1 no-gap-tb swimlanes">
            <div className="swim-column">
              <RxHistoryTable service={service} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FMRxHistory;
